import React from "react";
import { ClientApartment, ApartmentExtra, ReservationExtra, AptPackage, PromoValidateResult } from "../../../utils/api/apartmentRentalsAPI";
import { MealSelection } from "../../../utils/api/mealsAPI";
import { CalDate } from "./bookingPricing";
import MealSelector from "../MealSelector";
import PackagesBlock from "./PackagesBlock";
import ExtrasBlock from "./ExtrasBlock";
import ChildrenAgesBlock from "./ChildrenAgesBlock";
import PromoBlock from "./PromoBlock";

interface Props {
  apt: ClientApartment;
  checkIn: CalDate;
  checkOut: CalDate;
  nights: number;
  nightsTotal: number;
  totalPersons: number;
  matchedPackages: AptPackage[];
  applyPackage: boolean | null;
  selectedPackage: AptPackage | null;
  setApplyPackage: (v: boolean | null) => void;
  setSelectedPackage: (p: AptPackage | null) => void;
  childrenCount: number;
  childrenAges: number[];
  setChildrenAges: React.Dispatch<React.SetStateAction<number[]>>;
  selectedExtras: ReservationExtra[];
  toggleExtra: (extra: ApartmentExtra) => void;
  updateExtraQty: (extraId: string, qty: number) => void;
  onMealsChange: (sels: MealSelection[], total: number) => void;
  promoInput: string;
  setPromoInput: (v: string) => void;
  promoResult: PromoValidateResult | null;
  promoLoading: boolean;
  onValidatePromo: () => void;
  onClearPromo: () => void;
  lang: string;
  t: (key: any) => any;
}

const StepExtras: React.FC<Props> = ({
  apt, checkIn, checkOut, nights, nightsTotal, totalPersons,
  matchedPackages, applyPackage, selectedPackage, setApplyPackage, setSelectedPackage,
  childrenCount, childrenAges, setChildrenAges,
  selectedExtras, toggleExtra, updateExtraQty, onMealsChange,
  promoInput, setPromoInput, promoResult, promoLoading, onValidatePromo, onClearPromo,
  lang, t,
}) => {
  return (
    <div className="pab-step">
      <h2 className="pab-step__title">{lang === "en" ? "Anything extra?" : "Dodatne usluge"}</h2>
      <div className="pab-step__subtitle">
        {lang === "en" ? "Optional add-ons to make your stay better" : "Opciono — učinite boravak boljim"}
      </div>

      <PackagesBlock
        matchedPackages={matchedPackages}
        applyPackage={applyPackage}
        selectedPackage={selectedPackage}
        setApplyPackage={setApplyPackage}
        setSelectedPackage={setSelectedPackage}
        totalPersons={totalPersons}
        nights={nights}
        nightsTotal={nightsTotal}
        currency={apt.currency}
        t={t}
      />

      {applyPackage === true && selectedPackage?.childrenPricing && selectedPackage.childrenPricing.length > 0 && childrenCount > 0 && (
        <ChildrenAgesBlock
          childrenPricing={selectedPackage.childrenPricing}
          childrenCount={childrenCount}
          childrenAges={childrenAges}
          setChildrenAges={setChildrenAges}
          currency={apt.currency}
        />
      )}

      {apt.extras && apt.extras.length > 0 && (
        <ExtrasBlock
          extras={apt.extras}
          selectedExtras={selectedExtras}
          toggleExtra={toggleExtra}
          updateExtraQty={updateExtraQty}
          currency={apt.currency}
          title={lang === "en" ? "Add-ons" : "Dodatna ponuda"}
        />
      )}

      {apt.meals && apt.meals.length > 0 && (
        <MealSelector
          aptMeals={apt.meals}
          checkIn={checkIn}
          checkOut={checkOut}
          currency={apt.currency}
          capacity={apt.capacity}
          onChange={onMealsChange}
        />
      )}

      <div className="pab-block-title">{lang === "en" ? "Promo code" : "Promo kod"}</div>
      <PromoBlock
        promoInput={promoInput}
        setPromoInput={setPromoInput}
        promoResult={promoResult}
        promoLoading={promoLoading}
        onValidate={onValidatePromo}
        onClear={onClearPromo}
        currency={apt.currency}
        placeholder={t("promoCode")}
        applyLabel={t("apply")}
      />
    </div>
  );
};

export default StepExtras;
